module.exports = __webpack_public_path__ + "static/img/2_2_1.243df1da.jpg";